<ng-container *ngIf="auth.user?.country_id==233">
<div id="edit-personal-details" class="accord bg-white personal-detailsForm">
<div class="content-edit-area">
<div class="edit-content">
<div class="accordion md-accordion" id="accordionEx" role="tablist" aria-multiselectable="true">

<!-- Accordion card -->
<div class="card border-0">

<!-- Card header -->
<div class="card-header p-0 bg-white border-0" role="tab" id="headingOne1">
<a data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne1"
aria-expanded="true" aria-controls="collapseOne1">
<h5 class="mb-0">
<div class="row">
<div class="col-10 sm-14 color-blue mobile16">
    Add a new recipient
</div>
<div class="col-2">
    <i class="fas fa-angle-down rotate-icon float-right"></i>
</div>
</div>
</h5>
</a>
</div>

<!-- Card body -->
<div id="collapseOne1" class="collapse p-0" role="tabpanel" aria-labelledby="headingOne1"
data-parent="#accordionEx">
<div class="card-body p-0">

<form #usaContactForm="ngForm" (ngSubmit)="createContact(usaContactForm)">
<div class="row m-0 p-0">
<div class="col-12 mt-2 p-0">
<div class="sm-12 mobile16">
    <small class="sm-12 mobile16 mobile16 secondary-text font-weight-bold">
        About your recipient
    </small><br>
    <small class="sm-10 grey-text pb-4">
        Please note that incorrect details can delay payments.
    </small>
    <!-- <label for="input-zone">Country</label>
        <span style="color:red;">*</span> -->
        <input type="hidden" class="w-100" value="">
        <select 
        (change)="onCountryChange($event.target.value)" name="country_id"
        ngModel class="input_figma p-3 w-100 bg-white border-0 form-group mt-2 text-dark" required>
        <option value="" class="text-secondary" disabled selected> 
            Where is your recipient?
        </option>
        <option [value]="country.id" *ngFor="let country of countries">
            {{country.name}}
        </option>
    </select>
</div>
</div>
<ng-container *ngIf="selectedCountry==83">
<ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
    <li class="nav-item w-50 text-center">
        <a class="nav-link text-dark active border-0 bg-transparent sm-12 sm16 mobile14" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'ghs')">Bank transfer</a>
    </li>
    <li class="nav-item w-50 text-center">
        <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile14" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Mobile', 'ghs')">Mobile money</a>
    </li>
</ul>
<div class="row tab-content mx-0 w-100">
    
    <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
    id="bank"  aria-labelledby="bank-tab">
    <div class="col-12 m-0 p-0">
        <div class=" form-group sm-12 mobile16">
            <select (change)="onBankChange($event.target.value)" name="bank_id" ngModel
            class="input_figma p-3 w-100 bg-white border-0" required >
            <option value="" disabled selected> Bank name
            </option>
            <option [value]="bank.id" *ngFor="let bank of banks" >
                {{bank.name}}</option>
            </select>
        </div>
    </div>
    <div class="col-12 m-0 p-0">
        <div class="form-group sm-12 mobile16">
            <!-- <label class="form-label" for="input-zone">Branch Name</label>
                <span style="color:red;">*</span> -->
                <select name="branch_id" ngModel
                class="input_figma p-3 w-100 border-0 text-dark" required>
                <option value="" disabled selected> Branch name
                </option>
                <option [value]="branch.id" *ngFor="let branch of branches">
                    {{branch.name}}</option>
                </select>
            </div>
        </div>
    <div class="col-12 m-0 p-0">
        <div class="form-group sm-12 mobile16">
            <!-- <label class="form-label" for="input-zone">Account Type</label>
                <span style="color:red;">*</span> -->
                <select class="input_figma p-3 w-100 border-0 text-dark" name="account_type"
                ngModel required>
                <option value="" disabled selected> Account type
                </option>
                <option value="checking">Checking</option>
                <option value="savings">Savings</option>
            </select>
        </div>
    </div>
    <div class="col-12 m-0 p-0">
        <div class="form-group">
            <input type="text" name="account_number" ngModel
            class="input_figma p-3 w-100 sm-12 mobile16"
            placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
        </div>
    </div>
    <div class="col-12 m-0 p-0">
        <div class="form-group">
            <input type="text" name="confirm_account" ngModel
            class="input_figma p-3 w-100 sm-12 mobile16"
            placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
        </div>
    </div>
    </div>
    
    <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
    id="mobile"  aria-labelledby="mobile-tab">
    <div class="form-group sm-12 mobile16">
        <select name="mobile_provider_code" [(ngModel)]="provider_select"
        class="input_figma p-3 w-100 bg-white border-0" required>
            <option value="" disabled selected>     
                Who is your provider?
            </option>
            <option [value]="provider.code" *ngFor="let provider of providers">
                {{ provider.name }}
            </option>
        </select>
    </div>
    <div class="col-12 m-0 p-0">
        <div class="form-group d-flex w-100">
            <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                <span class="px-2 border-right border-dark">{{code_deposit}}</span>
            </div>
            <input type="text" name="deposit_number" ngModel
            class="input_figma p-3 w-100 sm-12 mobile16"
            placeholder="Enter deposit number" (keydown)="common.checkNumber($event,9)" required>
        </div>
    </div>
    </div>
    </div>



</ng-container>
<ng-container *ngIf="selectedCountry==101">

<div class="col-12 m-0 p-0">
    <!-- <label class="form-label" for="mobile-number">IFSC Code
        <span class="text-muted font-weight-500"></span>
        <span style="color:red;">*</span>
    </label> -->
    <div class="form-group d-flex justify-content-between">
        <input type="text" #ifsc="ngModel" ngModel name="ifsc_code"
        autocomplete="off" class="input_figma p-3 sm-12 mobile16" required
        placeholder="IFSC code of bank" style="width:70%">
        <span id="show_verify_button"></span>
        <button [disabled]="!ifsc.value" type="button"
        (click)="verifyIFSC(ifsc.value)"
        class="btn primary-btn px-3">Verify</button>
    </div>
</div>
<div class="col-12 m-0 p-0">
    <div class="form-group">
        <!-- <label class="form-label" for="mobile-number">Bank Name
            <span class="text-muted font-weight-500"></span>
            <span style="color:red;">*</span>
        </label> -->
        <input type="text" disabled [(ngModel)]="india_bank_name"
        name="bank_name" class="input_figma p-3 sm-12 mobile16 w-100"
        placeholder="Please verify IFSC code" required>
    </div>
</div>
<div class="col-12 m-0 p-0">
    <div class="form-group">
        <!-- <label for="account">Account Number<span
            class="text-danger">*</span></label> -->
            <input name="account_number" ngModel type="text"
            class="input_figma p-3 sm-12 mobile16 w-100"
            placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
        </div>
    </div>
    <div class="col-12 m-0 p-0">
        <div class="form-group">
            <!-- <label for="c_account">Confirm Account Number<span
                class="text-danger">*</span></label> -->
                <input type="text" name="confirm_account" ngModel
                class="input_figma p-3 sm-12 mobile16 w-100"
                placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
            </div>
        </div>
        <div class="col-12 m-0 p-0">
            <div class="form-group sm-12 mobile16 ">
                <!-- <label class="form-label" for="input-zone">Account Type</label>
                    <span style="color:red;">*</span> -->
                    <select class="input_figma p-3 w-100 bg-white border-0 text-dark"
                    name="account_type" ngModel required>
                    <option value="" disabled selected> Account Type</option>
                    <option value="checking">Checking</option>
                    <option value="savings">Savings</option>
                </select>
            </div>
        </div>
    </ng-container>
    
    <ng-container *ngIf="selectedCountry==113">
        <ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
            <li class="nav-item w-50 text-center">
                <a class="nav-link text-dark active border-0 bg-transparent sm-12 sm16 mobile14" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'kes')">Bank transfer</a>
            </li>
            <li class="nav-item w-50 text-center">
                <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile14" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Mobile', 'kes')">Mobile money</a>
            </li>
        </ul>
        <div class="row tab-content mx-0 w-100">
    
            <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
            id="bank"  aria-labelledby="bank-tab">
            <div class="col-12 m-0 p-0">
                <div class="form-group sm-12 mobile16">
                    <!-- <label class="form-label" for="input-zone">Bank Name</label>
                        <span style="color:red;">*</span> -->
                        <select name="bank_id" (change)="onBankChange($event.target.value)"
                        ngModel class="input_figma p-3 w-100  border-0 text-dark" required>
                        <option value="" disabled selected> Bank name
                        </option>
                        <option [value]="bank.id" *ngFor="let bank of banks">
                            {{bank.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 m-0 p-0">
                    <div class="form-group sm-12 mobile16">
                        <!-- <label class="form-label" for="input-zone">Branch Name</label>
                            <span style="color:red;">*</span> -->
                            <select name="branch_id" ngModel
                            class="input_figma p-3 w-100 border-0 text-dark" required>
                            <option value="" disabled selected> Branch name
                            </option>
                            <option [value]="branch.id" *ngFor="let branch of branches">
                                {{branch.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 m-0 p-0">
                        <div class="form-group sm-12 mobile16">
                            <!-- <label class="form-label" for="input-zone">Account Type</label>
                                <span style="color:red;">*</span> -->
                                <select class="input_figma p-3 w-100 border-0 text-dark" name="account_type"
                                ngModel required>
                                <option value="" disabled selected> Account type
                                </option>
                                <option value="checking">Checking</option>
                                <option value="savings">Savings</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 m-0 p-0">
                        <div class="form-group ">
                            <!-- <label for="account">Account Number<span
                                class="text-danger">*</span></label> -->
                                <input name="account_number" ngModel type="text"
                                class="input_figma p-3 w-100 sm-12 mobile16"
                                placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                            </div>
                        </div>
                        <div class="col-12 m-0 p-0">
                            <div class="form-group">
                                <!-- <label for="c_account">Confirm Account Number<span
                                    class="text-danger">*</span></label> -->
                                    <input type="text" name="confirm_account" ngModel
                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                    placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                </div>
                            </div>
            </div>
            
            <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
            id="mobile"  aria-labelledby="mobile-tab">
            <div class="form-group sm-12 mobile16">
                <select name="mobile_provider_code" [(ngModel)]="provider_select"
                class="input_figma p-3 w-100 bg-white border-0" required>
                    <option value="" disabled selected>     
                        Who is your provider?
                    </option>
                    <option [value]="provider.code" *ngFor="let provider of providers">
                        {{ provider.name }}
                    </option>
                </select>
            </div>
            <div class="col-12 m-0 p-0">
                <div class="form-group d-flex w-100">
                    <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                        <span class="px-2 border-right border-dark">{{code_deposit}}</span>
                    </div>
                    <input type="text" name="deposit_number" ngModel
                    class="input_figma p-3 w-100 sm-12 mobile16"
                    placeholder="Enter deposit number" (keydown)="common.checkNumber($event,9)" required>
                </div>
            </div>
            </div>
            </div>
        
                        
                    </ng-container>
                    
                    <ng-container *ngIf="selectedCountry==161">
                        
                        <div class="col-12 m-0 p-0">
                            <div class="form-group sm-12 mobile16">
                                <!-- <label class="form-label" for="input-zone">Bank Name</label>
                                    <span style="color:red;">*</span> -->
                                    <select #ngbankId="ngModel" name="bank_id"
                                    (change)="onBankChange($event.target.value)" ngModel
                                    class="input_figma p-3 w-100  border-0 texr-dark" required>
                                    <option value="" disabled selected> Bank name
                                    </option>
                                    <option [value]="bank.id" *ngFor="let bank of banks">
                                        {{bank.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 m-0 p-0">
                                <div class="form-group sm-12 mobile16">
                                    <!-- <label class="form-label" for="input-zone">Branch Name</label>
                                        <span style="color:red;">*</span> -->
                                        <select name="branch_id" ngModel
                                        class="input_figma p-3 w-100 border-0" required>
                                        <option value="" disabled selected> Branch name
                                        </option>
                                        <option [value]="branch.id" *ngFor="let branch of branches">
                                            {{branch.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12 m-0 p-0">
                                    <div class="form-group d-flex justify-content-between">
                                        <!-- <label for="account">Account Number<span
                                            class="text-danger">*</span></label> -->
                                            <!-- <div class="input-group "> -->
                                                <input (keyup)="ng_first_name='';ng_last_name=''" type="text" #ngaccountnumber="ngModel" ngModel
                                                name="account_number" autocomplete="off"
                                                class="input_figma p-3 sm-12 mobile16" required
                                                placeholder="Account number" style="width:70%">
                                                <span id="show_verify_button"></span>
                                                <button type="button"
                                                (click)="VerifyAccountNumber(ngbankId.value,ngaccountnumber.value)"
                                                class="btn primary-btn px-3">Verify</button>
                                                <!-- </div> -->
                                            </div>
                                        </div>
                                        <div class="col-12 m-0 p-0">
                                            <div class="form-group">
                                                <!-- <label for="firstName">First Name<span
                                                    class="text-danger">*</span></label> -->
                                                    <input readonly type="text" name="first_name"
                                                    [(ngModel)]="ng_first_name" class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="First name (as it appears on their account)" (keydown)="common.checkName($event, false, 25)"
                                                    required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <!-- <label for="fullName">Last Name<span
                                                        class="text-danger">*</span></label> -->
                                                        <input readonly type="text" name="last_name"
                                                        [(ngModel)]="ng_last_name" class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Last name (as it appears on their account)" (keydown)="common.checkName($event, false, 25)"
                                                        required>
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group sm-12 mobile16">
                                                        <!-- <label class="form-label" for="input-zone">Account Type</label>
                                                            <span style="color:red;">*</span> -->
                                                            <select class="input_figma p-3 w-100 border-0" name="account_type"
                                                            ngModel required>
                                                            <option value="" disabled selected> Account type
                                                            </option>
                                                            <option value="checking">Checking</option>
                                                            <option value="savings">Savings</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            
                                            
                                            
                                            <div *ngIf="selectedCountry!=161" class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="first_name" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="First name (as it appears on their account)" (keydown)="common.checkName($event, false, 25)" required>
                                                </div>
                                            </div>
                                            <div *ngIf="selectedCountry!=161" class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="last_name" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Last name (as it appears on their account)" (keydown)="common.checkName($event, false, 25)" required>
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group sm-12 mobile16">
                                                    <input type="hidden" class="w-100" id="state_val" value="">
                                                    <select class="input_figma p-3 w-100 border-0" name="state_id" ngModel
                                                    id="state_id" required>
                                                    <option value="" disabled selected> Their state</option>
                                                    <option [value]="state.id" *ngFor="let state of states">
                                                        {{state.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <!-- <label for="firstName">City<span class="text-danger">*</span></label> -->
                                                    <input type="text" name="city" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16" placeholder="Their city"
                                                    required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="postal_code" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16" placeholder="Their postal code"
                                                    required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="address_line1" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16" placeholder="Recipient address"
                                                    required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <!-- <label for="fullName">Address Line 2</label> -->
                                                    <input type="text" name="address_line2" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16" placeholder="Recipient street">
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="email" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Their email address" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group sm-12 mobile16">
                                                    <input type="hidden" class="w-100" id="state_val" value="">
                                                    <select class="p-3 w-100 border-0" name="sender_relationship" ngModel
                                                    id="sender_relationship" required>
                                                    <option value="" disabled selected>Relationship</option>
                                                    <option value="Aunt">Aunt</option>
                                                    <option value="Brother">Brother</option>
                                                    <option value="Brother in Law">Brother in Law</option>
                                                    <option value="Cousin">Cousin</option>
                                                    <option value="Daughter">Daughter</option>
                                                    <option value="Father">Father</option>
                                                    <option value="Father in Law">Father in Law</option>
                                                    <option value="Friends">Friends</option>
                                                    <option value="Grand Father">Grand Father</option>
                                                    <option value="Grand Mother">Grand Mother</option>
                                                    <option value="Husband">Husband</option>
                                                    <option value="Mother">Mother</option>
                                                    <option value="Mother in law">Mother in Law</option>
                                                    <option value="Nephew">Nephew</option>
                                                    <option value="Niece">Niece</option>
                                                    <option value="Self">Self</option>
                                                    <option value="Sister">Sister</option>
                                                    <option value="Sister in Law">Sister in Law</option>
                                                    <option value="Son">Son</option>
                                                    <option value="Uncle">Uncle</option>
                                                    <option value="Wife">Wife</option>
                                                </select>
                                            </div>
                                        </div>
                                        <button type="submit" class="btn primary-btn px-5 mt-3 w-100 mobile16">Add Recipient</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="auth.user?.country_id==39">
    <div id="edit-personal-details" class="accord bg-offwhite shadow personal-detailsForm">
        <div class="content-edit-area">
            <div class="edit-content">
                <div class="accordion" id="accordionExample">
                    <div class="card border-0">
                        <div class="card-header p-0 bg-white border-0" role="tab" id="headingOne">
                            <a data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne"
                            aria-expanded="true" aria-controls="collapseOne1">
                                <h5 class="mb-0">
                                    <div class="row">
                                        <div class="col-10 sm-14 color-blue ">
                                            Add a new recipient
                                        </div>
                                        <div class="col-2">
                                            <i class="fas fa-angle-down rotate-icon float-right"></i>
                                        </div>
                                    </div>
                                </h5>
                            </a>
                        </div>
                        
                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                        data-parent="#accordionExample">
                            <div class="card-body">
                                <form #caContactForm="ngForm" (ngSubmit)="createContact(caContactForm)">
                                    <div class="row">
                                        <div class="col-12 m-0 p-0">
                                            <small class="sm-12 mobile16 mobile16 secondary-text font-weight-bold">
                                                About your recipient
                                            </small><br>
                                            <small class="sm-10 grey-text pb-4">
                                                Please note that incorrect details can delay payments.
                                            </small>
                                            <div class="form-group sm-12 mobile16">
                                                <select (change)="onCountryChange($event.target.value)"
                                                name="payee_country" ngModel
                                                class="input_figma p-3 w-100 bg-white border-0" required>
                                                <option value="" disabled selected> 
                                                    Where is your recipient?
                                                </option>
                                                <option [value]="country.id" *ngFor="let country of countries">
                                                    {{country.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="selectedCountry==35 || selectedCountry==93 || selectedCountry==160 || selectedCountry==220 || selectedCountry==54 || selectedCountry==134 || selectedCountry==183 || selectedCountry==50 || selectedCountry==38 || selectedCountry==229" >
                                            <!-- BURKINA FASO, GUINEA BISSAU, NIGER, TOGO, IVORY COAST, MALI, CONGO, CAMEROON, UGANDA, RWANDA -->
                                            <div class="row tab-content mx-0 w-100">
                                                <div class="form-group sm-12 mobile16 w-100">
                                                    <select name="mobile_provider_code" [(ngModel)]="provider_select"
                                                    class="input_figma p-3 w-100 bg-white border-0" required>
                                                    <option value="" disabled selected>     
                                                        Who is your provider?
                                                    </option>
                                                    <option [value]="provider.code" *ngFor="let provider of providers">
                                                        {{ provider.name }}
                                                    </option>
                                                    </select>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group d-flex flex-wrap">
                                                        <div class="d-flex w-100">
                                                            <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                                                                <span class="px-2 border-right border-dark">{{code_deposit}}</span>
                                                            </div>
                                                            <input type="text" name="deposit_number" [(ngModel)]="provider_deposit"
                                                            class="input_figma p-3 sm-12 mobile16 w-100"
                                                            placeholder="Deposit number" (keydown)="common.checkNumber($event,9)" required>
                                                        </div>
                                                        <span class="sm-12 text-danger w-100" *ngIf="errDeposit">{{ errDeposit }}</span>
                                                        
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group">
                                                        <input type="text" name="payee_name" ngModel
                                                        class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="selectedCountry==24">
                                            <!-- BENIN -->
                                            <ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark active border-0 bg-transparent sm-12 sm16 mobile14" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'xof')">Bank transfer</a>
                                                </li>
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile14" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Mobile', 'xof')">Mobile money</a>
                                                </li>
                                            </ul>
                                            
                                            <div class="row tab-content mx-0 w-100">
                                                
                                                <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
                                                id="bank"  aria-labelledby="bank-tab">
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group sm-12 mobile16">
                                                            <select name="bank_name_id" ngModel
                                                            class="input_figma p-3 w-100 border-0" required>
                                                            <option value="" disabled selected> Bank name
                                                            </option>
                                                            <option [value]="bank.code" *ngFor="let bank of banks">
                                                                {{bank.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0 sm-12 mobile16">
                                                        <div class="form-group">
                                                            <input type="text" name="iban" ngModel
                                                            class="input_figma p-3 w-100 border-0" placeholder="IBAN"
                                                            required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="account_number" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="confirm_account" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="payee_name" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
                                                id="mobile"  aria-labelledby="mobile-tab">
                                                <div class="form-group sm-12 mobile16">
                                                        <select name="mobile_provider_code" [(ngModel)]="provider_select"
                                                        class="input_figma p-3 w-100 bg-white border-0" required>
                                                        <option value="" disabled selected>     
                                                            Who is your provider?
                                                        </option>
                                                        <option [value]="provider.code" *ngFor="let provider of providers">
                                                            {{ provider.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group d-flex flex-wrap">
                                                        <div class="d-flex w-100">
                                                            <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                                                                <span class="px-2 border-right border-dark">{{code_deposit}}</span>
                                                            </div>
                                                            <input type="text" name="deposit_number" [(ngModel)]="provider_deposit"
                                                            class="input_figma p-3 sm-12 mobile16 w-100"
                                                            placeholder="Deposit number" (keydown)="common.checkNumber($event,9)" required>
                                                        </div>
                                                        <span class="sm-12 text-danger w-100" *ngIf="errDeposit">{{ errDeposit }}</span>
                                                        
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group">
                                                        <input type="text" name="payee_name" ngModel
                                                        class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                    </div>
                                                </div>
                                                </div>
                                    
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="selectedCountry==83">
                                            <!-- GHANA -->
                                            <ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark active border-0 bg-transparent sm-12 sm16 mobile14" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'ghs')">Bank transfer</a>
                                                </li>
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile14" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Mobile', 'ghs')">Mobile money</a>
                                                </li>
                                            </ul>
                                            <div class="row tab-content mx-0 w-100">
                                                
                                                <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
                                                id="bank"  aria-labelledby="bank-tab">
                                                <div class="col-12 m-0 p-0">
                                                    <div class=" form-group sm-12 mobile16">
                                                        <select name="bank_name_id" ngModel
                                                        class="input_figma p-3 w-100 bg-white border-0" required>
                                                        <option value="" disabled selected> Bank name
                                                        </option>
                                                        <option [value]="bank.code" *ngFor="let bank of banks">
                                                            {{bank.name}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group">
                                                        <input type="text" name="account_number" ngModel
                                                        class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group">
                                                        <input type="text" name="confirm_account" ngModel
                                                        class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group">
                                                        <input type="text" name="payee_name" ngModel
                                                        class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
                                            id="mobile"  aria-labelledby="mobile-tab">
                                            <div class="form-group sm-12 mobile16">
                                                    <select name="mobile_provider_code" [(ngModel)]="provider_select"
                                                    class="input_figma p-3 w-100 bg-white border-0" required>
                                                    <option value="" disabled selected>     
                                                        Who is your provider?
                                                    </option>
                                                    <option [value]="provider.code" *ngFor="let provider of providers">
                                                        {{ provider.name }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group d-flex flex-wrap">
                                                    <div class="d-flex w-100">
                                                        <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                                                            <span class="px-2 border-right border-dark">{{code_deposit}}</span>
                                                        </div>
                                                        <input type="text" name="deposit_number" [(ngModel)]="provider_deposit"
                                                        class="input_figma p-3 sm-12 mobile16 w-100"
                                                        placeholder="Deposit number" (keydown)="common.checkNumber($event,9)" required>
                                                    </div>
                                                    <span class="sm-12 text-danger w-100" *ngIf="errDeposit">{{ errDeposit }}</span>
                                                    
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="payee_name" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                </div>
                                            </div>
                                            </div>
                                    
                                            </div>
                                
                                
                                
                                        </ng-container>
                                        <ng-container *ngIf="selectedCountry==101">
                                            <!-- INDIA -->
                                            <div class="col-12 m-0 p-0">
                                                <!-- <label class="form-label" for="mobile-number">IFSC Code
                                                    <span class="text-muted font-weight-500"></span>
                                                    <span style="color:red;">*</span>
                                                </label> -->
                                                <div class="form-group d-flex justify-content-between">
                                                    <input type="text" #ifsc="ngModel" ngModel name="ifsc_code"
                                                    autocomplete="off" class="input_figma p-3 sm-12 mobile16" required
                                                    placeholder="IFSC code of bank" style="width:70%">
                                                    <span id="show_verify_button"></span>
                                                    <button type="button" (click)="verifyIFSC(ifsc.value)"
                                                    class="btn primary-btn px-3">Verify</button>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <!-- <label class="form-label" for="mobile-number">Bank Name
                                                        <span class="text-muted font-weight-500"></span>
                                                        <span style="color:red;">*</span>
                                                    </label> -->
                                                    <input type="text" disabled [(ngModel)]="india_bank_name"
                                                    name="bank_name" class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Bank name" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="account_number" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="confirm_account" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="payee_name" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="selectedCountry==113">
                                            <!-- KENYA -->
                                            <ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
                                                <li class="nav-item sm-16 mobile14 w-50 text-center">
                                                    <a class="nav-link text-dark active border-0 bg-transparent sm-12 mobile14" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'kes')">Bank transfer</a>
                                                </li>
                                                <li class="nav-item sm-16 mobile14 w-50 text-center">
                                                    <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile14" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Mobile', 'kes')">Mobile money</a>
                                                </li>
                                            </ul>
                                            <div class="row tab-content mx-0 w-100">
                                                <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
                                                id="bank"  aria-labelledby="bank-tab">
                                                
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group sm-12 mobile16">
                                                        <!-- <label for="input-zone">Bank</label>
                                                            <span style="color:red;">*</span> -->
                                                            <select name="bank_name_id" [(ngModel)]="bank_select"
                                                            class="input_figma p-3 w-100 border-0" required>
                                                            <option value="" disabled selected> Bank name
                                                            </option>
                                                            <option [value]="bank.code" *ngFor="let bank of banks">
                                                                {{bank.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="account_number" [(ngModel)]="bank_account"
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="confirm_account" [(ngModel)]="bank_confirm"
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="payee_name" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
                                                id="mobile"  aria-labelledby="mobile-tab">
                                                    <div class="form-group sm-12 mobile16">
                                                        <select name="mobile_provider_code" [(ngModel)]="provider_select"
                                                        class="input_figma p-3 w-100 bg-white border-0" required>
                                                        <option value="" disabled selected> Who is your provider?
                                                        </option>
                                                        <option [value]="provider.code" *ngFor="let provider of providers">
                                                            {{ provider.name }}
                                                        </option>
                                                    </select>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group d-flex flex-wrap">
                                                            <div class="d-flex w-100">
                                                                <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                                                                    <span class="px-2 border-right border-dark">{{code_deposit}}</span>
                                                                </div>
                                                                <input type="text" name="deposit_number" [(ngModel)]="provider_deposit"
                                                                class="input_figma p-3 sm-12 mobile16 w-100"
                                                                placeholder="Deposit number" (keydown)="common.checkNumber($event,9)" required>
                                                            </div>
                                                            <span class="sm-12 text-danger w-100" *ngIf="errDeposit">{{ errDeposit }}</span>
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="payee_name" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="selectedCountry==161">
                                            <!-- NIGERIA -->
                                            <ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
                                                <li class="nav-item sm-16 mobile14 w-50 text-center">
                                                    <a class="nav-link text-dark active border-0 bg-transparent sm-12 mobile16" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'ngn')">Bank transfer</a>
                                                </li>
                                                <li class="nav-item sm-16 mobile14 w-50 text-center">
                                                    <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile16" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Mobile', 'ngn')">Mobile money</a>
                                                </li>
                                            </ul>
                                            <div class="row tab-content mx-0 w-100">
                                                
                                                <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
                                                id="bank"  aria-labelledby="bank-tab">
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="sm-12 form-group mobile16">
                                                            <select #ngbankId="ngModel" name="bank_name_id"
                                                            [(ngModel)]="bank_select"
                                                            class="input_figma p-3 w-100  border-0" required>
                                                                <option value="" disabled selected> 
                                                                    Bank name
                                                                </option>
                                                                <option [value]="bank.code" *ngFor="let bank of banks">
                                                                    {{bank.name}}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group d-flex justify-content-between">
                                                            <input (keyup)="ng_first_name=''" type="text" #ngaccountnumber="ngModel" [(ngModel)]="bank_account"
                                                            name="account_number" autocomplete="off"
                                                            class="input_figma p-3 sm-12 mobile16" required
                                                            placeholder="Account number" (keydown)="common.checkNumber($event,20)" style="width:70%">
                                                            
                                                            <button type="button"
                                                            (click)="VerifyAccountNumber(ngbankId.value,ngaccountnumber.value)"
                                                            class="btn primary-btn px-3 ">Verify</button>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input readonly type="text" name="payee_name"
                                                            [(ngModel)]="ng_first_name" class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Name (as it appears on their account)" (keydown)="common.checkName($event, false, 50)" required>
                                                        </div>
                                                    </div>
                                                </div>
                                        
                                                <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
                                                    id="mobile"  aria-labelledby="mobile-tab">
                                                    <div class="form-group sm-12 mobile16">
                                                        <select name="mobile_provider_code" [(ngModel)]="provider_select"
                                                        class="input_figma p-3 w-100 bg-white border-0" required>
                                                        <option value="" disabled selected>     
                                                            Who is your provider?
                                                        </option>
                                                        <option [value]="provider.code" *ngFor="let provider of providers">
                                                            {{ provider.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group d-flex flex-wrap">
                                                        <div class="d-flex w-100">
                                                            <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                                                                <span class="px-2 border-right border-dark">{{code_deposit}}</span>
                                                            </div>
                                                            <input type="text" name="deposit_number" [(ngModel)]="provider_deposit"
                                                            class="input_figma p-3 sm-12 mobile16 w-100"
                                                            placeholder="Deposit number" (keydown)="common.checkNumber($event,9)" required>
                                                        </div>
                                                        <span class="sm-12 text-danger w-100" *ngIf="errDeposit">{{ errDeposit }}</span>
                                                        
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group">
                                                        <input type="text" name="payee_name" ngModel
                                                        class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                    </div>
                                                </div>
                                                </div>
                                
                                            </div>
                                        </ng-container>
                                        <div *ngIf="selectedCountry==174 " class="col-12 m-0 p-0">
                                            <!-- PHILIPPINES -->
                                            <ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark active border-0 bg-transparent sm-12 sm16 mobile14" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'php')">Bank transfer</a>
                                                </li>
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile14" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Cash', 'php')">Cash transfer</a>
                                                </li>
                                            </ul>
                                            <div class="row tab-content mx-0 w-100">
                                                
                                                <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
                                                    id="bank"  aria-labelledby="bank-tab">
                                                    <div class="form-group sm-12 mobile16">
                                                        <select name="bank_name_id" ngModel
                                                        class="input_figma p-3 w-100 border-0" required>
                                                        <option value="" disabled selected> Bank name
                                                        </option>
                                                        <option [value]="bank.code" *ngFor="let bank of banks">
                                                            {{bank.name}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="account_number" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="confirm_account" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="payee_name" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
                                                id="mobile"  aria-labelledby="mobile-tab">
                                                
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="payee_name" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                        </div>
                                                    </div>
                                                </div>
                                    
                                            </div>
                                            
                                        </div>
                                        <div *ngIf="selectedCountry==45 || selectedCountry==102 || selectedCountry==240 || selectedCountry==199" class="col-12 m-0 p-0">
                                            <!--  || CHINA || VIETNAM || SINGAPORE || INDONESIA -->
                                            <div class="form-group sm-12 mobile16">
                                                <select name="bank_name_id" ngModel
                                                class="input_figma p-3 w-100 border-0" required>
                                                <option value="" disabled selected> Bank name
                                                </option>
                                                <option [value]="bank.code" *ngFor="let bank of banks">
                                                    {{bank.name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="account_number" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="confirm_account" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="payee_name" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="selectedCountry==195" class="col-12 m-0 p-0">
                                            <!-- SENEGAL -->
                                            <ul class="nav nav-tabs w-100 mb-2" id="myTab" role="tablist">
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark active border-0 bg-transparent sm-12 sm16 mobile14" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="true" (click)="changeType('Bank', 'xof')">Bank transfer</a>
                                                </li>
                                                <li class="nav-item w-50 text-center">
                                                    <a class="nav-link text-dark border-0 bg-transparent sm-12 mobile14" id="mobile-tab" data-toggle="tab" href="#mobile" role="tab" aria-controls="mobile" aria-selected="false" (click)="changeType('Mobile', 'xof')">Mobile money</a>
                                                </li>
                                            </ul>
                                            
                                            <div class="row tab-content mx-0 w-100">
                                                
                                                <div class="col-12 p-0 tab-pane fade show active" role="tabpanel" 
                                                id="bank"  aria-labelledby="bank-tab">
                                                    <div class="form-group sm-12 mobile16">
                                                        <select name="bank_name_id" ngModel
                                                        class="input_figma p-3 w-100 border-0" required>
                                                        <option value="" disabled selected> Bank name
                                                        </option>
                                                        <option [value]="bank.code" *ngFor="let bank of banks">
                                                            {{bank.name}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-12 m-0 p-0 sm-12 mobile16">
                                                        <div class="form-group">
                                                            <input type="text" name="iban" ngModel
                                                            class="input_figma p-3 w-100 border-0" placeholder="IBAN"
                                                            required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="account_number" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="confirm_account" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" (keydown)="common.checkNumber($event,20)" required>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 m-0 p-0">
                                                        <div class="form-group">
                                                            <input type="text" name="payee_name" ngModel
                                                            class="input_figma p-3 w-100 sm-12 mobile16"
                                                            placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                <div class="col-12 p-0 tab-pane fade" role="tabpanel" 
                                                id="mobile"  aria-labelledby="mobile-tab">
                                                <div class="form-group sm-12 mobile16">
                                                        <select name="mobile_provider_code" [(ngModel)]="provider_select"
                                                        class="input_figma p-3 w-100 bg-white border-0" required>
                                                        <option value="" disabled selected>     
                                                            Who is your provider?
                                                        </option>
                                                        <option [value]="provider.code" *ngFor="let provider of providers">
                                                            {{ provider.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group d-flex flex-wrap">
                                                        <div class="d-flex w-100">
                                                            <div class="d-flex align-items-center input_figma" style="border-radius: 5px 0px 0px 5px;" *ngIf="+code_deposit!=0">
                                                                <span class="px-2 border-right border-dark">{{code_deposit}}</span>
                                                            </div>
                                                            <input type="text" name="deposit_number" [(ngModel)]="provider_deposit"
                                                            class="input_figma p-3 sm-12 mobile16 w-100"
                                                            placeholder="Deposit number" (keydown)="common.checkNumber($event,9)" required>
                                                        </div>
                                                        <span class="sm-12 text-danger w-100" *ngIf="errDeposit">{{ errDeposit }}</span>
                                                        
                                                    </div>
                                                </div>
                                                <div class="col-12 m-0 p-0">
                                                    <div class="form-group">
                                                        <input type="text" name="payee_name" ngModel
                                                        class="input_figma p-3 w-100 sm-12 mobile16"
                                                        placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                    </div>
                                                </div>
                                                </div>
                                    
                                            </div>
                                            
                                        </div>
                                        <div *ngIf="selectedCountry==204" class="col-12 m-0 p-0">
                                            <!-- SOUTH AFRICA -->
                                            <div class="form-group sm-12 mobile16">
                                                <!-- <span style="color:red;">*</span>  -->
                                                <select name="bank_name_id" ngModel
                                                class="input_figma p-3 w-100 border-0" required>
                                                <option value="" disabled selected> Bank name
                                                </option>
                                                <option [value]="bank.code" *ngFor="let bank of banks">
                                                    {{bank.name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="account_number" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient account number" (keydown)="common.checkNumber($event,20)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="confirm_account" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Confirm account number" (keydown)="common.checkNumber($event,20)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="payee_name" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" minlength="11" maxlength="11" autocomplete="off"
                                                    name="payee_contact" ngModel class="input_figma p-3 w-100 sm-12 mobile16"
                                                    data-pr-form="mobile-number" required
                                                    placeholder="Recipient mobile number" (keydown)="common.checkNumber($event, 11)">
                                                </div>
                                            </div>
                                        </div>
                                        <ng-container *ngIf="selectedCountry==232 || selectedCountry == 15 || selectedCountry == 22 || selectedCountry == 57 || selectedCountry == 69 || selectedCountry == 74 || selectedCountry == 75 || selectedCountry == 82 || selectedCountry == 85 || selectedCountry == 105 || selectedCountry == 107 || selectedCountry == 120 || selectedCountry == 126 || selectedCountry == 127 || selectedCountry == 135 || selectedCountry == 145 || selectedCountry == 156 || selectedCountry == 177 || selectedCountry == 192 || selectedCountry == 200 || selectedCountry == 201 || selectedCountry == 207 ">
                                            <!-- UNITED KINGDOM -->
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="bank_name" [(ngModel)]=bank_name
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient's bank name "  (keydown)="common.checkName($event, true, 100)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0 sm-12 mobile16">
                                                <div class="form-group">
                                                    <input type="text" name="iban" [(ngModel)]="iban"
                                                    class="input_figma p-3 w-100 border-0" placeholder="IBAN" (keydown)="common.checkMaxLength($event, 28)"
                                                    required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="bic_swift" [(ngModel)]="bic_swift"
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="BIC swift" (keydown)="common.checkMaxLength($event, 11)" required>
                                                </div>
                                            </div>
                                            <div class="col-12 m-0 p-0">
                                                <div class="form-group">
                                                    <input type="text" name="payee_name" ngModel
                                                    class="input_figma p-3 w-100 sm-12 mobile16"
                                                    placeholder="Recipient name (alphabet only)" (keydown)="common.checkName($event, false, 50)" required>
                                                </div>
                                            </div>
                                        </ng-container>



                                        <!-- NICK NAME -->
                                        <div class="col-12 m-0 p-0">
                                            <div class="form-group">
                                                <input type="text" name="payee_nick_name" ngModel
                                                class="input_figma p-3 w-100 sm-12 mobile16" data-pr-form="fullName"
                                                id="fullName" placeholder="Recipient nick name (alphabet only)" (keydown)="common.checkName($event, false, 30)"
                                                required>
                                            </div>
                                        </div>

                                        <!-- STREET ADDRESS -->
                                        <div class="col-12 m-0 p-0">
                                            <div class="form-group">
                                                <input type="text" name="payee_address" ngModel
                                                class="input_figma p-3 w-100 sm-12 mobile16"
                                                placeholder="Recipient address" required>
                                            </div>
                                        </div>

                                        <!-- ADDRESS -->
                                        <div class="col-12 m-0 p-0">
                                            <div class="form-group">
                                                <input type="text" name="payee_street" ngModel
                                                class="input_figma p-3 w-100 sm-12 mobile16" data-pr-form="address"
                                                id="fullName" placeholder="Recipient street" required>
                                            </div>
                                        </div>

                                        <!-- CITY -->
                                        <div class="col-12 m-0 p-0">
                                            <div class="form-group">
                                                <input type="text" name="payee_city" ngModel
                                                class="input_figma p-3 w-100 sm-12 mobile16"
                                                placeholder="Recipient city" required>
                                            </div>
                                        </div>

                                        <!-- POSTAL CODE -->
                                        <div class="col-12 m-0 p-0">
                                            <div class="form-group">
                                                <input type="text" name="payee_postalCode" ngModel class="input_figma p-3 w-100 sm-12 mobile16" placeholder="Recipient postal code" (input)="convertToUpper($event)" required>
                                            </div>
                                        </div>

                                        <!-- MOBILE NUMBER -->
                                        <div class="col-12 m-0 p-0" *ngIf="!(selectedCountry==204) && !(transaction_type == 'Mobile') ">
                                            <div class="form-group">
                                                <input type="text" minlength="10" maxlength="10" autocomplete="off"
                                                name="payee_contact" ngModel class="input_figma p-3 w-100 sm-12 mobile16"
                                                data-pr-form="mobile-number" required
                                                placeholder="Recipient mobile number" (keydown)="common.checkNumber($event, 10)">
                                            </div>
                                        </div>

                                        <!-- EMAIL ADDRESS -->
                                        <div class="col-12 m-0 p-0">
                                            <div class="form-group">
                                                <input type="email" autocomplete="off" name="payee_email" ngModel
                                                class="input_figma p-3 w-100 sm-12 mobile16" required
                                                placeholder="Email address">
                                            </div>
                                        </div>

                                        <button type="submit" class="btn w-100 primary-btn my-3">Save Changes</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>